import React from 'react';

import Icon from '../Icon/Icon';

const DeliveryItemsIcon = (props) => {
    return (
        <Icon width='64' height='64' fill='none' {...props}>
            <path
                d='M34.6143 24C35.9505 24 37.0342 25.0837 37.0342 26.4199V28.3262C37.1821 28.148 37.4027 28.0323 37.6523 28.0322H46.084C46.9146 28.0322 47.6877 28.4585 48.1309 29.1611L52.8105 36.5811C53.0541 36.9673 53.1835 37.4145 53.1836 37.8711V46.666C53.1836 48.0078 52.0917 49.0938 50.75 49.0859L39.251 49.0176C38.252 49.0116 37.3981 48.4004 37.0342 47.5332V48.1943C37.0342 48.6397 36.6728 49.0008 36.2275 49.001H10.4199C9.08375 49.001 8.00011 47.9182 8 46.582V26.4199C8 25.0837 9.08368 24 10.4199 24H34.6143Z'
                fill='#393E44'
            />
            <path
                d='M44.0386 30.189C45.3132 30.1896 46.5116 30.7972 47.2648 31.8254L50.3535 36.042C50.5986 36.4307 50.7287 36.8808 50.7287 37.3403V38.0205C50.7287 38.4482 50.5074 38.895 50.0797 38.8984L40.5862 38.9735C39.9089 38.9788 39.3575 38.43 39.3599 37.7526L39.3761 31.4013C39.3784 30.7309 39.9225 30.1887 40.5929 30.1887H43.5846C43.5937 30.1887 43.6028 30.1888 44.0386 30.189Z'
                fill='#00D1D2'
            />
            <circle cx='19' cy='48.5' r='6' fill='#393E44' />
            <circle cx='19' cy='48.5' r='3' fill='#FFFDFB' />
            <circle cx='42' cy='48.5' r='6' fill='#393E44' />
            <circle cx='42' cy='48.5' r='3' fill='#FFFDFB' />
            <circle cx='44' cy='20' r='11' fill='#FFFDFB' stroke='#393E44' strokeWidth='2.5' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M44 13.6562C44.5523 13.6562 45 14.104 45 14.6562V19.5501L48.2727 22.8577C48.6612 23.2502 48.6578 23.8834 48.2653 24.2718C47.8727 24.6603 47.2395 24.657 46.8511 24.2644L43.2892 20.6646C43.1039 20.4773 43 20.2246 43 19.9612V14.6562C43 14.104 43.4477 13.6562 44 13.6562Z'
                fill='#393E44'
            />
        </Icon>
    );
};

export default DeliveryItemsIcon;
